// const price_filter = document.querySelector('[data-collapsible-id="filter-price"]');

(function () {
	function syncDepositAnniversary(variant) {
		document
			.querySelectorAll("[data-deposit-anniversary-variant-map]")
			.forEach(function (variantMap) {
				var form = variantMap.closest("form");
				if (!form) return;

				var anniversaryInput = form.querySelector(
					"[data-deposit-anniversary-input]"
				);
				if (!anniversaryInput) return;

				if (!variant) {
					anniversaryInput.value = "false";
					anniversaryInput.disabled = true;
					return;
				}

				var mapOption =
					variantMap.querySelector(
						'option[data-variant-id="' + variant.id + '"]'
					) ||
					variantMap.querySelector('option[value="' + variant.id + '"]');

				if (!mapOption) return;

				var hasAnniversaryBox =
					mapOption.dataset.realAnniversaryBox === "true";
				anniversaryInput.value = hasAnniversaryBox ? "true" : "false";
				anniversaryInput.disabled = !hasAnniversaryBox;
			});
	}

	document.addEventListener("variant:change", function (evt) {
		syncDepositAnniversary(evt.detail && evt.detail.variant);
	});
})();
// price_filter.textContent = 'Preis';